import React, { useCallback, useState } from 'react';
import { InterviewListItem } from '../../../entities/InterviewListItem';
import { DropdownInterview } from '../../DropdownInterview';
import { User } from '../../../entities/User';
import { CancelInterviewConfirmationModal } from '../../CandidatePage/InterviewsTab/CancelInterviewConfirmationModal';
import { JobHiringMemberRole } from '../../../entities/JobHiringMemberRole';
import { AlertType } from '../../../components/Alert';
import { redirectWithAlert } from '../../../services/FlashService';

interface PropTypes {
  applicationId: number;
  currentUser: User;
  jobHiringMemberRole: JobHiringMemberRole;
  interview: InterviewListItem;
}

export default function InterviewDropdownActions(props: PropTypes) {
  const [interviewToBeCancelled, setInterviewToBeCancelled] = useState(null);
  const [isCancelInterviewModalOpen, setIsCancelInterviewModalOpen] =
    useState(false);

  const onCancelInterview = useCallback(async (interviewId: string) => {
    setInterviewToBeCancelled(interviewId);
    setIsCancelInterviewModalOpen(true);
  }, []);

  const onSuccess = useCallback(() => {
    redirectWithAlert(
      window.location.href,
      'The interview was successfully cancelled!',
    );
  }, []);

  const onError = useCallback(() => {
    redirectWithAlert(
      window.location.href,
      'Could not cancel the interview! Please try again later.',
      AlertType.Danger,
    );
  }, []);

  return (
    <>
      <CancelInterviewConfirmationModal
        candidateName={props.interview.candidateName}
        interviewId={interviewToBeCancelled}
        isModalOpen={isCancelInterviewModalOpen}
        setIsModalOpen={setIsCancelInterviewModalOpen}
        onSuccess={onSuccess}
        onError={onError}
      />
      <DropdownInterview
        applicationId={props.applicationId}
        interview={props.interview}
        onCancelInterview={onCancelInterview}
        currentUser={props.currentUser}
        jobHiringMemberRole={props.jobHiringMemberRole}
      />
    </>
  );
}
